export default {"src":"/_next/static/media/contactPageBg.3c26f846.svg","height":494,"width":1440,"blurWidth":0,"blurHeight":0};